var _path, _g, _g2, _path2, _g3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.191,
    height: 67.191,
    viewBox: "0 0 67.191 67.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.98,22.962h0a30.175,30.175,0,0,1-15.441-4.188A38.957,38.957,0,0,1,0,4.781C.073,4.732,8.317,0,8.44,0a22.266,22.266,0,0,0,8.219,8.724,25.582,25.582,0,0,0,13.578,4.225c5.5,0,13.393-2.2,19.807-12.667.087.032,9.126,3.928,9.166,3.984a31.492,31.492,0,0,1-11.989,13.3,35.536,35.536,0,0,1-8.663,3.957A33.114,33.114,0,0,1,28.98,22.962Zm14-11.344a3.651,3.651,0,1,0,3.65,3.65A3.655,3.655,0,0,0,42.979,11.618Z",
    transform: "translate(4.305 42.982)",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.753 9.754)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.842,0A23.842,23.842,0,1,1,0,23.842,23.842,23.842,0,0,1,23.842,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.84186553955078 2.999996185302734 C 21.02690505981445 2.999996185302734 18.29774475097656 3.550636291503906 15.73018646240234 4.636627197265625 C 13.24871444702148 5.686195373535156 11.01948547363281 7.189384460449219 9.104434967041016 9.104434967041016 C 7.189384460449219 11.01948547363281 5.686195373535156 13.24871444702148 4.636627197265625 15.73018646240234 C 3.550636291503906 18.29774475097656 2.999996185302734 21.02690505981445 2.999996185302734 23.84186553955078 C 2.999996185302734 26.65682601928711 3.550636291503906 29.385986328125 4.636627197265625 31.95353507995605 C 5.686195373535156 34.43501663208008 7.189384460449219 36.66423416137695 9.104434967041016 38.57928466796875 C 11.01948547363281 40.49433517456055 13.24871444702148 41.99752426147461 15.73018646240234 43.04710388183594 C 18.29774475097656 44.13308715820313 21.02690505981445 44.6837272644043 23.84186553955078 44.6837272644043 C 26.65682601928711 44.6837272644043 29.385986328125 44.13308715820313 31.95353507995605 43.04710388183594 C 34.43501663208008 41.99752426147461 36.66423416137695 40.49433517456055 38.57928466796875 38.57928466796875 C 40.49433517456055 36.66423416137695 41.99752426147461 34.43501663208008 43.04710388183594 31.95353507995605 C 44.13308715820313 29.385986328125 44.6837272644043 26.65682601928711 44.6837272644043 23.84186553955078 C 44.6837272644043 21.02690505981445 44.13308715820313 18.29774475097656 43.04710388183594 15.73018646240234 C 41.99752426147461 13.24871444702148 40.49433517456055 11.01948547363281 38.57928466796875 9.104434967041016 C 36.66423416137695 7.189384460449219 34.43501663208008 5.686195373535156 31.95353507995605 4.636627197265625 C 29.385986328125 3.550636291503906 26.65682601928711 2.999996185302734 23.84186553955078 2.999996185302734 M 23.84186553955078 -3.814697265625e-06 C 37.00936508178711 -3.814697265625e-06 47.6837272644043 10.67436599731445 47.6837272644043 23.84186553955078 C 47.6837272644043 37.00936508178711 37.00936508178711 47.6837272644043 23.84186553955078 47.6837272644043 C 10.67436599731445 47.6837272644043 -3.814697265625e-06 37.00936508178711 -3.814697265625e-06 23.84186553955078 C -3.814697265625e-06 10.67436599731445 10.67436599731445 -3.814697265625e-06 23.84186553955078 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6,0A33.6,33.6,0,1,1,0,33.6,33.6,33.6,0,0,1,33.6,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.59535980224609 3 C 29.46369171142578 3 25.45720291137695 3.808521270751953 21.68718338012695 5.403099060058594 C 18.04425811767578 6.943923950195313 14.7719612121582 9.150379180908203 11.9611701965332 11.96117782592773 C 9.150371551513672 14.77196884155273 6.943916320800781 18.04426574707031 5.403091430664063 21.68719100952148 C 3.808513641357422 25.45719909667969 2.999992370605469 29.46368789672852 2.999992370605469 33.59535598754883 C 2.999992370605469 37.72702026367188 3.808513641357422 41.73351287841797 5.403091430664063 45.50352478027344 C 6.943916320800781 49.14644622802734 9.150371551513672 52.41874694824219 11.9611701965332 55.22953414916992 C 14.7719612121582 58.04033279418945 18.04425811767578 60.24678802490234 21.68718338012695 61.78761291503906 C 25.45720291137695 63.3821907043457 29.46369171142578 64.19071197509766 33.59535980224609 64.19071197509766 C 37.72702789306641 64.19071197509766 41.73351287841797 63.3821907043457 45.50352478027344 61.78761291503906 C 49.14644622802734 60.24678802490234 52.41874694824219 58.04033279418945 55.22953796386719 55.22953414916992 C 58.04033660888672 52.41874694824219 60.24679183959961 49.14644622802734 61.78761672973633 45.50352478027344 C 63.38219451904297 41.73351287841797 64.19071197509766 37.72702026367188 64.19071197509766 33.59535598754883 C 64.19071197509766 29.46368789672852 63.38219451904297 25.45719909667969 61.78761672973633 21.68719100952148 C 60.24679183959961 18.04426574707031 58.04033660888672 14.77196884155273 55.22953796386719 11.96117782592773 C 52.41874694824219 9.150379180908203 49.14644622802734 6.943923950195313 45.50352478027344 5.403099060058594 C 41.73351287841797 3.808521270751953 37.72702789306641 3 33.59535980224609 3 M 33.59535980224609 0 C 52.14955902099609 0 67.19071197509766 15.04115676879883 67.19071197509766 33.59535598754883 C 67.19071197509766 52.14955520629883 52.14955902099609 67.19071197509766 33.59535980224609 67.19071197509766 C 15.0411491394043 67.19071197509766 -7.62939453125e-06 52.14955520629883 -7.62939453125e-06 33.59535598754883 C -7.62939453125e-06 15.04115676879883 15.0411491394043 0 33.59535980224609 0 Z",
    stroke: "none",
    fill: "currentColor"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.8-11.168v7.144c0,3.572,1.018,5.167,3.768,5.167s3.768-1.6,3.768-5.167v-7.144H-10.3v7.421c0,1.7-.5,2.549-1.733,2.549s-1.733-.85-1.733-2.549v-7.421ZM-.8.935l3.122-12.1H.277l-1.43,5.809-.729,3.8h-.041l-.756-3.8-1.43-5.809H-6.228L-3.134.935Zm9.847,0,3.122-12.1H10.123L8.693-5.359l-.729,3.8H7.923l-.756-3.8-1.43-5.809H3.618L6.713.935Z",
    transform: "translate(35.921 39.163)",
    fill: "currentColor"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.542 1.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,2.167,9.753",
    transform: "translate(26.009)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.167,0,0,9.753",
    transform: "translate(39.014)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.419,0,0,7.586",
    transform: "translate(47.684 6.502)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67,0,0,4.335",
    transform: "translate(54.187 18.423)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.753,0H0",
    transform: "translate(56.354 32.512)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67,3.793,0,0",
    transform: "translate(54.187 42.265)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.877,8.67,0",
    transform: "translate(3.793 41.723)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H9.753",
    transform: "translate(0 31.97)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,8.67,5.419",
    transform: "translate(3.251 17.34)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,5.419,7.586",
    transform: "translate(13.005 6.502)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.162,7.25,0,0",
    transform: "translate(47.552 49.851)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.118,9.215,0,0",
    transform: "translate(38.048 54.186)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.215,2.118,0",
    transform: "translate(26.136 54.186)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.773,5.96,0",
    transform: "translate(12.463 49.851)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 3.5,
    rx: 4,
    ry: 3.5,
    transform: "translate(52.551 11.114)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvv);
export default __webpack_public_path__ + "static/media/uvv.d6949d9f404c2cb4007aefd8565d2bb0.svg";
export { ForwardRef as ReactComponent };